import { render, staticRenderFns } from "./TalentModule.vue?vue&type=template&id=3afe4bb2"
import script from "./TalentModule.vue?vue&type=script&lang=ts"
export * from "./TalentModule.vue?vue&type=script&lang=ts"
import style0 from "./TalentModule.vue?vue&type=style&index=0&id=3afe4bb2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports